module.exports = __webpack_public_path__ + "img/1.da2fbec4.png";